import { render, staticRenderFns } from "./SMSMessenger.vue?vue&type=template&id=00511160&scoped=true"
import script from "./SMSMessenger.vue?vue&type=script&lang=js"
export * from "./SMSMessenger.vue?vue&type=script&lang=js"
import style0 from "./SMSMessenger.vue?vue&type=style&index=0&id=00511160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00511160",
  null
  
)

export default component.exports